import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaBars, FaTimes, FaUser } from "react-icons/fa";
import BrandLogo from "../BrandLogo";
import { useAuth } from "../../context/AuthContext";

const LandingNavbar: React.FC = () => {
  const { t } = useTranslation(["home", "common"]);
  const { isAuthenticated, logout } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);

  const closeMobile = () => setMobileOpen(false);

  return (
    <header className="sticky top-0 z-50 bg-space/95 backdrop-blur-md border-b border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-[72px] md:h-20 gap-4">
          <Link to="/" className="shrink-0 min-w-0">
            <BrandLogo className="h-12 md:h-14 w-auto min-w-[220px] md:min-w-[300px]" />
          </Link>

          <div className="hidden md:flex items-center gap-4 shrink-0 ml-auto">
            {isAuthenticated ? (
              <div className="relative group">
                <button
                  type="button"
                  className="flex items-center text-gray-300 hover:text-neon-green transition-colors p-1"
                  aria-label={t("common:profile")}
                >
                  <FaUser size={18} />
                </button>
                <div className="absolute right-0 w-44 mt-2 py-2 bg-space-light rounded-md shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 border border-white/10">
                  <Link
                    to="/profile"
                    className="block px-4 py-2 text-body-sm text-gray-300 hover:bg-white/5 transition-colors"
                  >
                    {t("common:profile")}
                  </Link>
                  <Link
                    to="/orders"
                    className="block px-4 py-2 text-body-sm text-gray-300 hover:bg-white/5 transition-colors"
                  >
                    {t("common:orders")}
                  </Link>
                  <button
                    type="button"
                    onClick={logout}
                    className="block w-full text-left px-4 py-2 text-body-sm text-red-400 hover:bg-white/5 transition-colors"
                  >
                    {t("common:logout")}
                  </button>
                </div>
              </div>
            ) : (
              <>
                <Link
                  to="/login"
                  className="text-body-sm text-gray-300 hover:text-neon-green font-medium transition-colors"
                >
                  {t("common:login")}
                </Link>
                <Link
                  to="/register"
                  className="text-body-sm px-4 py-2 rounded-full border border-white/20 text-gray-300 hover:border-neon-green/50 hover:text-neon-green transition-colors"
                >
                  {t("common:register")}
                </Link>
              </>
            )}
          </div>

          <button
            type="button"
            className="md:hidden text-gray-300 hover:text-neon-green p-2 shrink-0"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label={mobileOpen ? "關閉選單" : "開啟選單"}
            aria-expanded={mobileOpen}
          >
            {mobileOpen ? <FaTimes size={22} /> : <FaBars size={22} />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden border-t border-white/5 px-4 py-3 space-y-1">
          {isAuthenticated ? (
            <>
              <Link
                to="/profile"
                className="block text-body-sm text-gray-300 hover:text-neon-green py-2.5"
                onClick={closeMobile}
              >
                {t("common:profile")}
              </Link>
              <Link
                to="/orders"
                className="block text-body-sm text-gray-300 hover:text-neon-green py-2.5"
                onClick={closeMobile}
              >
                {t("common:orders")}
              </Link>
              <button
                type="button"
                onClick={() => {
                  logout();
                  closeMobile();
                }}
                className="block w-full text-left text-body-sm text-red-400 py-2.5"
              >
                {t("common:logout")}
              </button>
            </>
          ) : (
            <div className="pt-2 flex flex-col gap-2">
              <Link
                to="/login"
                className="block text-center w-full px-4 py-2.5 rounded-full text-body-sm font-medium text-space bg-neon-green hover:opacity-90"
                onClick={closeMobile}
              >
                {t("common:login")}
              </Link>
              <Link
                to="/register"
                className="block text-center w-full px-4 py-2.5 rounded-full border border-white/20 text-body-sm font-medium text-gray-300 hover:border-neon-green/50 hover:text-neon-green"
                onClick={closeMobile}
              >
                {t("common:register")}
              </Link>
            </div>
          )}
        </div>
      )}
    </header>
  );
};

export default LandingNavbar;
